<template>
  <div class="page-email-confirmation">
    <div class="page-email-confirmation__header">
      <Beacon class="page-email-confirmation__beacon" />
    </div>

    <div class="page-email-confirmation__content">
      <BaseLoadingBar v-if="pending" />
      <EmailConfirmationError v-else-if="error" :error="error" @send-new-email="sendEmail" />
      <LargeNotice
        v-else-if="resolved"
        v-on:click="redirect"
        :title="$t('email-confirmation.congrats')"
        :subtitle="$t('email-confirmation.success')"
        :buttonText="$t('login.log-in')"
        buttonIcon="arrow-right"
        success
      />
    </div>
  </div>
</template>

<script>
import BaseLoadingBar from '@/components/base/BaseLoadingBar';
import Beacon from '@/components/Beacon.vue';
import EmailConfirmationError from '@/components/page-email-confirmation/EmailConfirmationError';
import LargeNotice from '@/components/notice/LargeNotice';
import { paths } from '@/util/paths';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PageEmailConfirmation',
  components: {
    BaseLoadingBar,
    Beacon,
    EmailConfirmationError,
    LargeNotice,
  },
  props: {
    token: String,
  },
  computed: {
    ...mapGetters('confirmEmail', ['pending', 'error', 'resolved']),
  },
  methods: {
    ...mapActions('confirmEmail', ['confirmEmail']),
    ...mapActions('sendEmailConfirmation', ['resendEmail']),
    redirect() {
      this.$router.push(paths.login);
    },
    sendEmail() {
      this.resendEmail(this.token);
      this.$toast.success(this.$t('email-confirmation.email-sent'));
    },
  },
  created() {
    if (!this.$route.params.token) {
      this.$router.push(paths.login);
      return;
    }
    this.confirmEmail(this.token).then(() => {
      this.$track.inviteSuccess();
    });
  },
};
</script>

<style lang="scss">
.page-email-confirmation {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  min-height: var(--viewport-height);
  padding: 32px;
  width: 100%;

  &__header {
    display: flex;
    max-width: initial;

    width: 100%;
  }

  &__back {
    align-items: center;
    color: $color-normal;
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-decoration: none;

    &:hover,
    &:focus,
    &:active {
      color: $color-accent;
    }

    &-icon {
      color: $color-neutral;
      height: 1.4rem;
      margin-right: 8px;
      width: 20px;
    }

    &-text {
      font-size: $font-size-small;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  &__beacon {
    margin-left: auto;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 450px;
    margin: auto;
    min-height: 80px !important;
  }
}

@media screen and (max-width: 784px) {
  .page-email-confirmation {
    &__content {
      width: 100%;
    }

    &__header {
      max-width: 450px;
    }
  }
}
</style>
